import { PrensaEngineCSSProp } from '@xprog/prensa/types'
import { Block, IconButton, Link } from '@xprog/prensa'
import { SearchIcon } from 'components/Assets/SearchIcon'
import { Input } from 'components/Input/Input.styles'
import React, { KeyboardEvent } from 'react'

interface SearchInputProps extends React.InputHTMLAttributes<HTMLInputElement>{
  buttonId?: string;
  css?: {
    container?: PrensaEngineCSSProp;
    icon?: { button?: PrensaEngineCSSProp; };
    input?: PrensaEngineCSSProp;
  };
  onSearch: () => void;
};

const SearchInput: React.FC<SearchInputProps> = ({ buttonId, onSearch, css, ...otherProps }) => {

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSearch()
    }
  }

  return (
    <Block
      css={{
        align: ['row', 'between', 'middle'],
        position: 'relative',
        width: '100%',
        ...css?.container
      }}
    >
      <Input
        placeholder='Digite o que você procura'
        type='text'
        onKeyUp={handleKeyPress}
        css={{
          borderColor: '#BFBFBF',
          borderRadius: '$default',
          borderStyle: 'solid',
          borderWidth: '1px',
          backgroundRepeat: 'no-repeat',
          backgroundPositionX: 'calc(100% - 16px)',
          backgroundPositionY: '50%',
          color: '#A0A0A0',
          fontFamily: '$primary',
          fontSize: '$headline6',
          fontWeight: '$headline6',
          lineHeight: '$headline6',
          height: '40px',
          px: '$4',
          pr: '$13',
          m: '$0',
          width: '100%',
          ...css?.input
        }}
        {...otherProps}
      />
      <IconButton
        color='basicWhite'
        onClick={onSearch}
        icon={<SearchIcon />}
        id={buttonId}
        roundedCorners='unset'
        size='sm'
        variant='outlined'
        css={{
          button: {
            position: 'absolute',
            borderLeft: '1px solid #e6e6e6',
            minWidth: '$8',
            pl: '$2',
            right: '$5',
            ...css?.icon?.button
          }
        }}
      />
    </Block>
  )
}


export default SearchInput
